export const validateShipments = (data) => {
  const errors = [];
  if (!data || data.length === 0) {
    errors.push(`No shipment found.`);
  }
  data?.forEach((item, index) => {
    const rowNo = index + 1;

    // Check if required fields are present
    if (!item.label) {
      errors.push(`Row ${rowNo}: "label" is required.`);
    }
    if (!item.deliveryDuration) {
      errors.push(`Row ${rowNo}: "deliveryDuration" is required.`);
    }
  });
  return errors;
};

export const validateVehicles = (data) => {
  const errors = [];
  if (!data || data.length === 0) {
    errors.push(`No vehicle found.`);
  }
  data?.forEach((item, index) => {
    const rowNo = index + 1;

    // Check if required fields are present
    if (!item.label) {
      errors.push(`Row ${rowNo}: "label" is required.`);
    }
    if (!item.travelMode) {
      errors.push(`Row ${rowNo}: "travelMode" is required.`);
    }
  });
  return errors;
};
